export default "__VITE_ASSET___NbD04TV__"